import { APP_STORE_URL, PLAY_STORE_URL } from "@/utils/deepLink";

export type TopAnnouncementSlideId =
  | "app"
  | "trust"
  | "delivery"
  | "agencies"
  | "guestCheckout";

export interface TopAnnouncementSlideConfig {
  id: TopAnnouncementSlideId;
  messageKey: string;
  ctaKey?: string;
  /** Internal route or external URL */
  href?: string;
  /** Open app stores (resolved in component for mobile platform) */
  externalStore?: boolean;
  /** Only show on iOS/Android mobile web */
  mobileOnly?: boolean;
  /** Hide when user is logged in */
  guestOnly?: boolean;
  /** Hide for owners (show for guest + renter) */
  hideForOwner?: boolean;
  /** Agency recruitment is for public visitors, not admins or the admin dashboard. */
  hideForAdminAndDashboards?: boolean;
}

export const TOP_ANNOUNCEMENT_SLIDES: TopAnnouncementSlideConfig[] = [
  {
    id: "app",
    messageKey: "topBar.slides.app.message",
    ctaKey: "topBar.slides.app.cta",
    href: "/search?focus=location",
    mobileOnly: true,
    guestOnly: true,
  },
  {
    id: "trust",
    messageKey: "topBar.slides.trust.message",
    ctaKey: "topBar.slides.trust.cta",
    href: "/search",
  },
  {
    id: "delivery",
    messageKey: "topBar.slides.delivery.message",
    ctaKey: "topBar.slides.delivery.cta",
    href: "/search?focus=location",
  },
  {
    id: "agencies",
    messageKey: "topBar.slides.agencies.message",
    ctaKey: "topBar.slides.agencies.cta",
    href: "/agences",
    hideForOwner: false,
    hideForAdminAndDashboards: true,
  },
  {
    id: "guestCheckout",
    messageKey: "topBar.slides.guestCheckout.message",
    ctaKey: "topBar.slides.guestCheckout.cta",
    href: "/search",
    guestOnly: true,
  },
];

export const shouldShowAgencyAnnouncement = (input: {
  isAdmin: boolean;
  isDashboardSession: boolean;
}): boolean => !input.isAdmin && !input.isDashboardSession;

export const DEFAULT_STORE_URL = PLAY_STORE_URL;

export { APP_STORE_URL, PLAY_STORE_URL };
